import $ from 'jquery';


import Top from './view/top';
import Philosophy from './view/philosophy';
import About from './view/about';
import Factory from './view/factory';
import Dinewith from './view/dinewith';

import Navigation from './utill/navigation';
import SNS from './utill/sns';
import UA from './utill/ua';


$(function() {
  const pageName = $('body').attr('id');

  const _ua = new UA;

  new Navigation;
  new SNS;

  switch(pageName) {
    case 'js-topPage':
      new Top;
      break;
    case 'js-philoPage':
      new Philosophy;
      break;
    case 'js-aboutPage':
      new About;
      break;
    case 'js-factoryPage':
      new Factory;
      break;
    case 'js-dinePage':
      new Dinewith;
      break;
    default:
      break;
  }
})



/** WEBPACK FOOTER **
 ** ./htdocs_dev/js/app.js
 **/